import PropTypes from "prop-types";
import React, { Component } from "react";

import { Spinner } from "reactstrap";

// Redux
import { connect } from "react-redux";
import i18n from "../../i18n";
import { withTranslation } from "react-i18next";

// actions
import { getPaymentPageTransactionByUniqueId, hostedPaymentPageApiError } from "../../store/actions";
import { getLinkPaymentErrorMessage, linkPaymentSetIcon, linkPaymenSetMessage, linkPaymentIsSuccess } from "../../components/Common/TableComponents/AgTable/CellRenderers/CellFunctions";
import HostedPaymentPage from "pages/HostedPaymentPage/hostedPaymentPage";

import { 
  CheckoutErrorForm,
  ThreeDForm,
} from "components/Common/CombinedComponents";
import { getApiErrorDetails } from "helpers/apiErrorHelper";

class HostedPaymentPageCheckout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedClient: null,
      record: {
        message: "",
        code: "",
        details: "",
        correlationId: "",
        validationResults: [],
      },
      loading: true,
      open: false,
      redirectToErrorPage: false,
      selectedLang: "",
    };

  }

  componentDidMount() {
    this.props.error("");
    const { onGetPaymentPageTransactionByUniqueId } = this.props;

    let uniqueIdVal = this.getUniqueIdFromUrl()
    let paymentPageTransactionFilter = { uniqueId: uniqueIdVal }

    onGetPaymentPageTransactionByUniqueId(paymentPageTransactionFilter);
  }

  componentDidUpdate(prevProps, prevState) { 
    const { error, loading, paymentPageTransactionRecord, result } = this.props;
    if (prevProps.error === error) {
      return;
    }
    if (!error || (typeof error === "object" && !error.response && !error.Code && !error.Message && !error.message && Object.keys(error).length === 0)) {
      return;
    }

    const paymentFormVisible = !loading && paymentPageTransactionRecord && !result?.error && !result?.nonSecureTransaction && !result?.secureTransaction;
    if (paymentFormVisible) {
      return;
    }

    const { record } = this.state;
    try {
      const details = getApiErrorDetails(error);
      record.code = details.code;
      record.message = details.message;
      record.details = details.details;
      record.correlationId = details.correlationId;
    } catch (e) {
      record.code = "Unhandled Exeption";
      record.message = "Please contact with Administrator";
    }
    this.setState({ error: record });
  }


  getUniqueIdFromUrl = () => {
    const url = window.location.href;
    const uniqueId = url.slice(-44);
    return uniqueId;
  };

  render() {

    return (
      <React.Fragment>
        {this.props.loading ? (
          <Spinner className="position-absolute top-50 start-50 primary" />
        ) :
          this.props.result?.error || this.props.result?.nonSecureTransaction ? (
            <CheckoutErrorForm
              errorMessage={getLinkPaymentErrorMessage(this.props.result)}
              errorIcon={linkPaymentSetIcon(this.props.result)}
              errorResult={linkPaymenSetMessage(this.props.result)}
              errorIsSuccess={linkPaymentIsSuccess(this.props.result)}
            />
          ) : this.props.result?.secureTransaction ? (
            <ThreeDForm
              base64Response={this.props.result}
            />
          ) : (
            <HostedPaymentPage
              paymentPageTransactionRecord={this.props.paymentPageTransactionRecord}
            />
          )
        }
      </React.Fragment>
    );
  }
}

HostedPaymentPageCheckout.propTypes = {
  onGetPaymentPageTransactionByUniqueId: PropTypes.func,
  paymentPageTransactionRecord: PropTypes.any,
  apiError: PropTypes.any,
  error: PropTypes.any,
  t: PropTypes.any,
  loading: PropTypes.bool,
  result: PropTypes.any
};

const mapStateToProps = ({ hostedPaymentPage }) => ({
  loading: hostedPaymentPage.loading,
  result: hostedPaymentPage.record,
  paymentPageTransactionRecord: hostedPaymentPage.recordList,
  error: hostedPaymentPage.error
});

const mapDispatchToProps = dispatch => ({
  onGetPaymentPageTransactionByUniqueId: paymentPageTransactionFilter => dispatch(getPaymentPageTransactionByUniqueId(paymentPageTransactionFilter)),
  error: error => dispatch(hostedPaymentPageApiError(error)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(HostedPaymentPageCheckout));
